import React from "react";
import Image from "next/image";
import Link from "next/link";
import { newsBlogFormatDate } from "@/utils/helpers/formatDate";
const RelatedBlogPage = ({ relatedPosts }: any) => {
  return (
    <section className="w-full">
      <h6 className="text-xl font-semibold pb-4 text-primary">Related Post</h6>
      <div className="flex overflow-auto hide-scrollbar md:grid md:grid-cols-3 gap-4">
        {relatedPosts
          ?.slice()
          ?.slice(0, 6)
          ?.map(
            (post: {
              blog_url: any;
              id: number;
              blog_title: string;
              featured_image: {
                id: number;
                name: string;
                url: string;
              };
              updatedAt: string;
            }) => (
              <div
                key={post.id}
                className="relative rounded-lg overflow-hidden min-w-[90%] md:min-w-full"
              >
                <Image
                  src={post.featured_image.url}
                  objectFit="cover"
                  width={1000}
                  height={1000}
                  className="h-48 md:h-48 w-full"
                  alt={post.blog_title}
                />
                <div className="absolute inset-0 bg-black opacity-60 h-full w-full pt-4 flex" />
                <div className="absolute inset-0 flex flex-col justify-end p-4 text-white">
                  <div className="text-base md:text-lg font-semibold mb-2 line-clamp-2">
                    <Link href={`/blogs/${post.blog_url}`}>
                      {" "}
                      {post.blog_title.slice(0, 100)}
                    </Link>
                  </div>
                  <div className="text-xs">
                    {newsBlogFormatDate(post.updatedAt)}{" "}
                  </div>
                </div>
              </div>
            )
          )}
      </div>
    </section>
  );
};

export default RelatedBlogPage;
